import { render, staticRenderFns } from "./TheSubMenu.vue?vue&type=template&id=17d9a6e5"
import script from "./TheSubMenu.vue?vue&type=script&lang=js"
export * from "./TheSubMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports